export default function About() {
  return (
    <div
      className="min-h-screen bg-cover bg-center text-gray-800 flex flex-col"
      style={{ backgroundImage: "url('/background50.jpg')" }}
    >
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="bg-white bg-opacity-90 shadow-xl rounded-2xl p-10 max-w-4xl w-full">
          <h1 className="text-4xl font-bold mb-6 text-center text-olive">About Common Roots Composting</h1>
          <p className="text-lg leading-relaxed mb-8 text-center text-black">
            Common Roots Composting is a community-led initiative based in Robeson Meadows, focused on closing the loop between food waste and soil health. By turning scraps into soil, we’re nurturing both the planet and our neighborhoods.
          </p>

          <div className="grid md:grid-cols-2 gap-8 text-left">
            <div>
              <h2 className="text-2xl font-semibold mb-2 text-sienna">Our Mission</h2>
              <p className="text-black">
                To make composting simple, social, and scalable — reducing waste, enriching gardens, and connecting people with their communities.
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold mb-2 text-sienna">Our Vision</h2>
              <p className="text-black">
                A neighborhood where every household is empowered to regenerate soil, reduce waste, and foster environmental stewardship.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
